import React, { useEffect, useState } from "react";
import LoginSlide from "./components/loginSlide";
import { useNavigate } from "react-router-dom";

export default function LoginClient() {
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let intervalTime = 100; // start with 100ms
    let interval;

    const startInterval = (time) => {
      interval = setInterval(() => {
        setProgress((prev) => {
          let next = prev + 1;

          // adjust speed based on thresholds
          if (next === 50) {
            clearInterval(interval);
            startInterval(500);
          } else if (next === 80) {
            clearInterval(interval);
            startInterval(1000);
          }

          // stop at 95%
          if (next >= 95) {
            clearInterval(interval);
            return 95;
          }

          return next;
        });
      }, time);
    };

    startInterval(intervalTime);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <LoginSlide progress={progress} />
    </>
  );
}
